import slice from '../reducer/slice';

import { StatusLoading } from 'common/constants/statusLoading';

const { setUserGeoPositionLoading } = slice.actions;

type Operation = (statusLoading?: StatusLoading) => void;

const operation: Operation = (StatusLoading) => setUserGeoPositionLoading(StatusLoading);

export default operation;
